import React from "react";
import { ISentence } from "us.collection.case/interfaces";
import { $AmountLabel, $DatePicker, $Input, $InputAmount } from "us.common/components";
import { ISentenceRow } from "../..";

export const SentenceRow: React.FC<
  ISentenceRow & {
    currentCurrency: string;
    currentLanguage: string;
    currentDateFormat: string;
    values: ISentence;
  }
> = (props) => {
  const {
    currentCurrency,
    currentLanguage,
    currentDateFormat,
    values,
    heading,
    amountLabel,
    inputAmountName,
    interestFromName,
    interestRateName,
    interestToName,
  } = props;

  return (
      <div className="list-table-row" key={interestFromName}>
        <div className="list-table-col text-nowrap">{heading}</div>
        <div className="list-table-col text-right text-nowrap">
          <strong>
            <$AmountLabel value={amountLabel} />
          </strong>
        </div>
        <div className="list-table-col ans-agreement">
          <$InputAmount
            className="text-right w-100"
            size="small"
            name={inputAmountName}
            currentCurrency={currentCurrency}
            currentLanguage={currentLanguage}
            value={values[inputAmountName] as number}
            ini
          />
        </div>
        <div className="list-table-col">
          <$DatePicker
            name={interestFromName ?? inputAmountName.toString() + "_interestFrom"}
            data-testid={"sentence-interest-from-"+inputAmountName?.toString()}
            disabled={!interestFromName}
            size="small"
            style={{ width: "100%" }}
            format={currentDateFormat}
            value={interestFromName && values[interestFromName]}
          />
        </div>
        <div className="list-table-col">
          <$DatePicker
            name={interestToName ?? inputAmountName.toString() + "_interestTo"}
            disabled={!interestToName}
            data-testid={"sentence-interest-to-"+inputAmountName?.toString()}
            size="small"
            style={{ width: "100%" }}
            format={currentDateFormat}
            value={interestToName && values[interestToName]}
          />
        </div>
        <div className="list-table-col">
          <>
            <$Input
              className="text-left"
              size="small"
              name={interestRateName ?? inputAmountName.toString() + "_interestRate"}
              disabled={!interestRateName}
              suffix={<>{"%"}</>}
            />
          </>
        </div>
      </div>
  );
};
